import React from 'react';
import { Link } from 'react-router-dom';
import { calendarMeta, seasonBlocks } from '../data/seasonCalendar';
import '../styles/Calendar.css';

const Calendar = () => {
  return (
    <div className="apple-page apple-calendar">
      <header className="apple-page-hero">
        <p className="apple-eyebrow">Calendar</p>
        <h1 className="apple-display">{calendarMeta.title}</h1>
        <p className="apple-lede">{calendarMeta.lede}</p>
        <p className="apple-calendar-meta">업데이트 {calendarMeta.updatedAt}</p>
      </header>

      <ul className="apple-calendar-list">
        {seasonBlocks.map((block) => (
          <li key={block.id}>
            <p className="apple-calendar-season">{block.season}</p>
            <h2>{block.title}</h2>
            <p className="apple-calendar-approx">{block.approx}</p>
            <h3>할 일</h3>
            <ol>
              {block.actions.map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ol>
            <h3>확인처</h3>
            <ul className="apple-calendar-links">
              {block.links.map((link) => (
                <li key={link.label}>
                  {link.url ? (
                    <a href={link.url} target="_blank" rel="noopener noreferrer">
                      {link.label}
                    </a>
                  ) : (
                    <Link to={link.path}>{link.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>

      <aside className="apple-article-note">
        이 페이지는 시즌 프레임입니다. 시험 당일·마감 시각은 JASSO·DNC·대사관·대학 공고 원문으로
        확정하세요.
      </aside>

      <div className="apple-page-foot">
        <Link to="/alerts" className="apple-btn apple-btn-primary">
          시즌 알림 신청
        </Link>
        <Link to="/pass" className="apple-link">
          시즌패스
        </Link>
        <Link to="/resources" className="apple-link">
          공식 자료
        </Link>
        <Link to="/glossary" className="apple-link">
          용어집
        </Link>
        <Link to="/guides" className="apple-link">
          가이드
        </Link>
      </div>
    </div>
  );
};

export default Calendar;
